import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay/classic';
import { Link, withRouter } from 'react-router';
import classNames from 'classnames';
import MerchantWalletBanner from 'components/widgets/MerchantWalletBanner';
import ZapCashBanner from 'components/widgets/ZapCashBanner';
import { handleChange } from 'components/helpers/utils';
import { ZInput } from 'components/widgets/ZElements';
import LinkTagMutation from 'mutations/LinkTagMutation';

import '../styles/wallet.less';
import '../styles/wallet-memberships.less';

class Wallet extends React.Component {
  static propTypes = {
    relay: PropTypes.shape({
      forceFetch: PropTypes.func
    }).isRequired,
    viewer: PropTypes.shape({
      zapperId: PropTypes.string,
      auth: PropTypes.shape({
        email: PropTypes.string
      }),
      profile: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        birthday: PropTypes.string,
        gender: PropTypes.string,
        streetAddress: PropTypes.string,
        locationId: PropTypes.string,
        image: PropTypes.string
      }),
      zapCashCurrencyBalance: PropTypes.shape({
        name: PropTypes.string,
        redeemable: PropTypes.number
      }),
      currencyBalances: PropTypes.shape({
        edges: PropTypes.arrayOf(
          PropTypes.shape({
            node: PropTypes.shape({
              id: PropTypes.string,
              name: PropTypes.string,
              image: PropTypes.string,
              acceptingBranchesCount: PropTypes.number,
              pendingEarn: PropTypes.number,
              redeemable: PropTypes.number,
              rawId: PropTypes.string
            })
          })
        )
      }),
      memberships: PropTypes.shape({
        edges: PropTypes.arrayOf(
          PropTypes.shape({
            node: PropTypes.shape({
              id: PropTypes.string,
              tag: PropTypes.shape({
                code: PropTypes.string,
                image: PropTypes.string
              }),
              activeRank: PropTypes.shape({
                rank: PropTypes.shape({
                  id: PropTypes.string,
                  name: PropTypes.string,
                  image: PropTypes.string
                }),
                expiry: PropTypes.number
              }),
              image: PropTypes.string
            })
          })
        )
      })
    }).isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      currentTab: 'points',
      showAddForm: false,
      linkMessage: 'LINK',
      isBusy: false,
      zapCode: '',
      pin: '',
      showError: false,
      errorMessage: 'Unable to link tag'
    };
    this.handleChange = handleChange.bind(this);
  }

  componentWillMount() {
    const { viewer, router } = this.props;
    let zapperId = viewer ? viewer.zapperId : null;
    if (!zapperId) {
      router.replace('/login');
    } else if (zapperId && !this.isCompleteProfile()) {
      router.replace('/profile');
    }
  }

  onLinktagSuccess() {
    this.props.relay.forceFetch({}, readyState => {
      if (readyState.done) {
        console.log('Relay store updated');
      }
    });

    this.setState({ linkMessage: 'LINK SUCCESSFUL', isBusy: false });
    this.popupid = setTimeout(() => {
      if (this.popupid !== null) {
        clearTimeout(this.popupid);
        this.popupid = null;
      }
      this.setState({
        linkMessage: 'LINK',
        showAddForm: false,
        zapCode: '',
        pin: ''
      });
      this.refs.zapCode.resetToPristine();
      this.refs.pin.resetToPristine();
    }, 5000);
  }

  onLinkTagFailure(e) {
    let errorMsg =
      e.getError().source.errors[0].error.code === 400
        ? 'Invalid tag code/pin'
        : this.state.errorMessage;

    this.setState({
      errorMessage: errorMsg,
      showError: true,
      isBusy: false
    });
    this.refs.zapCode.invalidate();
    this.refs.pin.invalidate();
  }

  isCompleteProfile() {
    let viewer = this.props.viewer;
    let profile = viewer.profile;
    let email = viewer.auth ? viewer.auth.email : viewer.auth;
    if (
      email &&
      profile.firstName &&
      profile.lastName &&
      profile.birthday &&
      profile.gender &&
      profile.locationId
    ) {
      return true;
    }
    return false;
  }

  tabClicked = e => {
    this.setState({ currentTab: e.target.id });
  };

  fetchTabs() {
    return [
      {
        id: 'points'
      },
      {
        id: 'memberships'
      }
    ];
  }

  formatDate(d) {
    let dd = d.getDate();
    let mm = d.getMonth() + 1;
    let yyyy = d.getFullYear();

    if (dd < 10) dd = '0' + dd;

    if (mm < 10) mm = '0' + mm;

    return mm + '/' + dd + '/' + yyyy;
  }

  toggleAdder() {
    this.setState({ showAddForm: !this.state.showAddForm });
  }

  handleAddSubmit(event) {
    event.preventDefault();

    let onSuccess = () => {
      this.onLinktagSuccess();
    };
    let onFailure = e => {
      this.onLinkTagFailure(e);
    };
    let mutation = new LinkTagMutation({
      zapCode: this.state.zapCode,
      pin: this.state.pin
    });
    Relay.Store.commitUpdate(mutation, { onSuccess, onFailure });
    this.setState({ isBusy: true, showError: false });
  }

  renderMerchantWalletPoints = () => {
    let pointsClassName = classNames('points-container', {
      active: this.state.currentTab === 'points'
    });

    let zapCashBalance = this.props.viewer.zapCashCurrencyBalance
      ? this.props.viewer.zapCashCurrencyBalance.redeemable
      : 0;

    let balances;

    if (this.props.viewer.currencyBalances.edges.length > 0) {
      balances = this.props.viewer.currencyBalances.edges.map(
        this.renderMerchantWalletBanner
      );
    } else {
      balances = (
        <div className="no-points">
          <span>No Points</span>
        </div>
      );
    }

    return (
      <div className={pointsClassName}>
        <div className="section-border wallet">
          <div className="section-title wallet">Points</div>
        </div>
        <div className="body">
          <ZapCashBanner zapCashBalance={zapCashBalance} />
          <div className="points-banners-container">{balances}</div>
        </div>
      </div>
    );
  };

  renderMerchantWalletBanner(balances) {
    let balance = balances.node;
    if (balance.redeemable > 0 || balance.pendingEarn > 0) {
      let link = '/merchants?redemptionCurrencyId=' + balance.rawId;
      return (
        <Link
          className="merchant-wallet-banner-container"
          to={link}
          key={balance.id}
        >
          <MerchantWalletBanner
            logo={balance.image}
            merchantName={balance.name}
            numBranches={balance.acceptingBranchesCount}
            clearedPoints={balance.redeemable}
            pendingPoints={balance.pendingEarn}
          />
        </Link>
      );
    }
  }

  renderMerchantWalletMemberships() {
    let membershipsList = this.props.viewer.memberships.edges;
    let membershipClassName = classNames({
      active: this.state.currentTab === 'memberships'
    });

    let addFormClass = classNames({
      'add-membership-form': true,
      down: this.state.showAddForm
    });

    let errorClassNames = classNames('reset-error', {
      hide: !this.state.showError
    });

    let memberships;
    if (membershipsList.length > 0) {
      memberships = membershipsList.map(membership => {
        let membershipImage = membership.node.image;

        let memKey = membership.node.id;
        return (
          <div className="membership-block-container" key={memKey}>
            <div className="membership" key={memKey}>
              <div className="card-image-container">
                <img className="card-image" src={membershipImage} />
              </div>

              <div className="card-info">
                {membership.node.tag
                  ? this.renderMembershipInfoBlock(
                      'Card Number:',
                      membership.node.tag.code
                    )
                  : null}
                {membership.node.activeRank
                  ? this.renderMembershipInfoBlock(
                      'Rank:',
                      membership.node.activeRank.rank.name
                    )
                  : null}
                {membership.node.activeRank
                  ? this.renderMembershipInfoBlock(
                      'Valid Until:',
                      this.formatDate(
                        new Date(membership.node.activeRank.expiry)
                      )
                    )
                  : null}
                <img
                  className="rank-img"
                  src={
                    membership.node.activeRank
                      ? membership.node.activeRank.rank.image
                      : null
                  }
                />
              </div>
            </div>
          </div>
        );
      });
    } else {
      memberships = (
        <div className="no-memberships">
          <span>No Memberships</span>
        </div>
      );
    }

    return (
      <div id="wallet-memberships" className={membershipClassName}>
        <div className="section-border wallet">
          <div className="section-title wallet">Membership</div>
        </div>
        <div className="membership-adder">
          <a onClick={() => this.toggleAdder()}>
            <div className="logo">+</div> <span> LINK TAG</span>
          </a>
          <form
            className={addFormClass}
            onSubmit={event => this.handleAddSubmit(event)}
          >
            <ZInput
              required
              type="text"
              ref="zapCode"
              name="zapCode"
              value={this.state.zapCode}
              onChange={this.handleChange}
              placeholder="Tag Code"
            />
            <ZInput
              required
              type="text"
              ref="pin"
              name="pin"
              value={this.state.pin}
              onChange={this.handleChange}
              placeholder="PIN"
            />
            <button type="submit" disabled={this.state.isBusy}>
              {this.state.linkMessage}
            </button>
            <div className={errorClassNames}>
              <span>{this.state.errorMessage}</span>
            </div>
          </form>
        </div>
        <div className="memberships-container">{memberships}</div>
      </div>
    );
  }

  renderMembershipInfoBlock(label, info) {
    return (
      <div className="info-block">
        <div className="label">{label}</div>
        <div className="info">{info}</div>
      </div>
    );
  }

  renderTabs = tab => {
    let itemClassNames = classNames('tab-item', {
      active: this.state.currentTab === tab.id
    });

    return (
      <div key={tab.id} className="tab">
        <div id={tab.id} className={itemClassNames} onClick={this.tabClicked}>
          {tab.id}
        </div>
      </div>
    );
  };

  render() {
    let tabs = this.fetchTabs();

    let points = this.renderMerchantWalletPoints();
    let membership = this.renderMerchantWalletMemberships();

    return (
      <div id="wallet">
        <div className="offwhite-bg" />
        <div className="tabs">{tabs.map(this.renderTabs)}</div>
        {points}
        {membership}
      </div>
    );
  }
}

export default Relay.createContainer(withRouter(Wallet), {
  initialVariables: {
    currencyBalancesCount: 10,
    membershipsCount: 10
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        zapperId,
        auth {
          email,
        },
        profile { 
          firstName,
          lastName,
          birthday,
          gender,
          locationId,
          image(size: "140x140")
        },
        zapCashCurrencyBalance {
          name,
          redeemable
        },
        currencyBalances(first: $currencyBalancesCount) {
          edges {
            node {
              id,
              name,
              image,
              acceptingBranchesCount,
              pendingEarn,
              redeemable,
              rawId,
            }
          }
        },
        memberships(first: $membershipsCount) {
          edges {
            node {
              id
              tag {
                code,
                image
              },
              activeRank {
                rank {
                  id,
                  name,
                  image
                },
                expiry
              },
              image
            }
          }
        }
      }`
  }
});



// WEBPACK FOOTER //
// ./js/components/pages/Wallet.js